import {Editor} from "react-draft-wysiwyg";
import {EditorState, RichUtils} from 'draft-js';
import './RichEditorStyleSheet.css'
import React from 'react';
import {useEffect, useState} from "react";
import {ContentState, convertFromHTML} from "draft-js";
import {stateToHTML} from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const AdvanceRichEditor = ({text, setText}) => {

    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    function onEditorStateChange(editorState) {
        setEditorState(editorState)
        const contentState = editorState.getCurrentContent();
        setText(stateToHTML(contentState))
    }

    useEffect(() => {
        const contentState = editorState.getCurrentContent();
        const editorText = stateToHTML(contentState)


        if (typeof text !== 'undefined') {
            if (text.length > 0 ) {
                if (editorText !== text){
                    const contentState = convertFromHTML(text)
                    const content = ContentState.createFromBlockArray(
                        contentState.contentBlocks,
                        contentState.entityMap
                    );
                    setEditorState(EditorState.createWithContent(content))
                }
            } else {
                setEditorState(EditorState.createEmpty())
            }
        }
    }, [text])

    return (
        <div className='RichEditor-root'>
            <div className='RichEditor-editor font_primary'>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                />
            </div>
        </div>
    )
};
export default AdvanceRichEditor;